import { Box, Grid, Typography } from '@mui/material';
import Layout from '../../components/layout';
import GeneralSellAndBuybackSetting from '../Sell/GeneralSellAndBuybackSetting';
import React, { useEffect, useState } from 'react';
import CurrentPrice from '../../components/current-price';
import { useTrigger } from '../../components/useTrigger';
import PreviewBuybackPrice from '../../components/PreviewBuybackPrice';
import { useDialogContext } from '../../components/dialog-context';
import { bullionTypes } from '../../core-bullions/bullions-core-config';
import { services } from '../Sell/services';
import { useToastContext } from '../../components/toast-context';
import CurrentBuybackPrice from '../../components/currentBuybackPrice';

export const getprofitPercentage = bullionData => {
  let profitPercentage = null;
  let profitPercentageVariable = null;

  if (bullionData?.buybackStrategy === 'MANUAL') {
    profitPercentage = bullionData.manualBuybackMarginPercentage;
    profitPercentageVariable = 'manualBuybackMarginPercentage';
  } else if (bullionData?.buybackStrategy === 'AUTOMATIC_ESTJT') {
    profitPercentage = bullionData.estjtBuybackMarginPercentage;
    profitPercentageVariable = 'estjtBuybackMarginPercentage';
  }

  return { profitPercentage, profitPercentageVariable };
};

const Buyback = () => {
  const manualPriceLessThanThreshhold = false;
  const manualPriceMoreThanThreshhold = false;

  const [prices, setPrices] = React.useState({
    GB_999_1: { BUYBACK: 0 },
    GB_999_2: { BUYBACK: 0 },
    GB_999_5: { BUYBACK: 0 },
    GB_999_10: { BUYBACK: 0 },
    GB_999_20: { BUYBACK: 0 },
    GB_999_50: { BUYBACK: 0 },
    GB_999_100: { BUYBACK: 0 },
    GB_995_1: { BUYBACK: 0 },
    GB_995_2: { BUYBACK: 0 },
    GB_995_5: { BUYBACK: 0 },
    GB_995_10: { BUYBACK: 0 },
    GB_995_20: { BUYBACK: 0 },
    GB_995_50: { BUYBACK: 0 },
    GB_995_100: { BUYBACK: 0 },
  });
  const [bullionsConfig, setBullionsConfig] = React.useState([]);
  const [isPriceFirstLoading, setIsPriceFirstLoading] = React.useState(true);

  const [showPreview, setShowPreview] = React.useState(false);
  const [configValues, setConfigValues] = React.useState();

  const [currentStratgy, setCurrentStratgy] = React.useState('');
  const [changedPreviewProductConfig, setChangedPreviewProductConfig] =
    React.useState([]);
  const [estjPrices, setEstjPrices] = React.useState();

  const { trigger, trig } = useTrigger();
  const { showToast } = useToastContext();

  const [manualBullionsConfig, setManualBullionsConfig] = React.useState([]);
  const { openDialog, closeDialog } = useDialogContext();
  useEffect(() => {
    services.getProductsConfig({}).then(data => {
      setBullionsConfig(data || []);
    });
  }, [currentStratgy, trigger]);

  useEffect(() => {
    services.getProductsConfig({ buybackStrategy: 'MANUAL' }).then(data => {
      setManualBullionsConfig(data || []);
    });
  }, [currentStratgy, trigger]);

  const pricePerGram = estjPrices?.gold24k * 10;

  useEffect(() => {
    if (configValues?.strategy !== 'MANUAL') {
      setShowPreview(false);
    }
  }, [
    configValues?.strategy,
    configValues?.costPercentage,
    configValues?.manualBasePrice,
  ]);
  useEffect(() => {
    services.getEstjPrices().then(prices => {
      setEstjPrices(prices);
    });
  }, [trigger]);

  useEffect(() => {
    services.get995Price().then(prices => {
      setPrices(prices);
      setIsPriceFirstLoading(false);
    });
  }, [trigger]);

  const setProductConfig = async (rawData, productType) => {
    const { isPreview, ...data } = rawData;

    if (isPreview) {
      setChangedPreviewProductConfig(prev => {
        const isExisting = prev.findIndex(
          product => product.productType === productType
        );

        if (isExisting !== -1) {
          const updatedItems = [...prev];
          updatedItems[isExisting] = { ...data.data, productType };
          return updatedItems;
        }
        return [...prev, { ...data.data, productType }];
      });

      return;
    }

    try {
      const res = await services.setProductConfig({
        productType,
        ...data,
        transactionType: 'SELL',
      });
      if (res) {
        const theBullionIndex = bullionsConfig.findIndex(
          b => b.productType === productType
        );
        const theBullion = bullionsConfig[theBullionIndex];
        bullionsConfig.splice(theBullionIndex, 1);
        if (res.buybackCutNumber || res.buybackCutNumber === 0) {
          theBullion.buybackCutNumber = res.buybackCutNumber;
        }
        const currConfigProfitVariable =
          getprofitPercentage(res).profitPercentageVariable;

        if (
          res[currConfigProfitVariable] ||
          res[currConfigProfitVariable] === 0
        ) {
          theBullion[currConfigProfitVariable] = res[currConfigProfitVariable];
        }
        setBullionsConfig(rest => {
          return [...rest, theBullion];
        });
      }
      const changedBullions = changedPreviewProductConfig.reduce(
        (acc, curr, i) => {
          const theBullion = bullionTypeList.find(
            bullion => bullion.key === curr.productType
          );

          if (
            changedPreviewProductConfig?.length === 1 ||
            i === changedPreviewProductConfig?.length - 1
          ) {
            return (acc += `${theBullion.name} `);
          }
          return (acc += `${theBullion.name} و `);
        },
        ''
      );

      showToast(` تنظیمات ${changedBullions} با موفقیت ثبت شد.`, 'success');
      setChangedPreviewProductConfig([]);
      closeDialog();
    } catch (error) {
      console.error('Error setting product config:', error);
      let toastMessage = 'خطایی رخ داده است.';
      if (error.response) {
        toastMessage =
          error.response.data?.message ||
          'خطایی در سرور رخ داد. لطفا دوباره تلاش کنید.';
      } else if (error.request) {
        toastMessage =
          'اتصال به اینترنت برقرار نیست. لطفاً شبکه خود را بررسی کنید.';
      } else {
        toastMessage = 'یک خطای غیرمنتظره در برنامه رخ داد.';
      }
      showToast(toastMessage, 'error');
    }
  };

  const bullionTypeList = bullionTypes({
    bullionsConfig,
    pricePerGram,
    prices,
    configValues,
    manualBullionsConfig,
    changedPreviewProductConfig,
    setProductConfig,
    isBuyback: true,
  });

  return (
    <>
      {/* <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: 700,
          color: '#111827',
          letterSpacing: '0.5px',
        }}
      >
        عملیات بازخرید
      </Typography> */}
      <GeneralSellAndBuybackSetting
        type="SELL"
        setShowPreview={setShowPreview}
        setConfigValues={setConfigValues}
        trig={trig}
        trigger={trigger}
        setCurrentStratgy={setCurrentStratgy}
      />

      <Box
        dir="rtl"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          // marginTop: { xs: '80px', sm: '110px', md: '80px', lg: '60px' },
          // backgroundColor: '#f9fafb',
          // minHeight: '100vh',
          mt: 3,
          // px: { xs: 2, md: 6 },
        }}
      >
        <Grid
          pr={'0 !important'}
          container
          spacing={0}
          gap={3}
          justifyContent="center"
          alignItems="center"
          sx={{
            maxWidth: '1648px',
          }}
        >
          {showPreview && (
            <PreviewBuybackPrice
              pricePerGram={pricePerGram}
              manualBasePrice={configValues?.manualBasePrice}
              setShowPreview={setShowPreview}
              setProductConfig={setProductConfig}
              changedPreviewProductConfig={changedPreviewProductConfig}
              configValues={configValues}
              setBullionsConfig={setBullionsConfig}
              trig={trig}
              trigger={trigger}
              openDialog={openDialog}
              manualPriceLessThanThreshhold={manualPriceLessThanThreshhold}
              bullionTypes={bullionTypeList}
              manualPriceMoreThanThreshhold={manualPriceMoreThanThreshhold}
            />
          )}

          <CurrentBuybackPrice
            pricePerGram={pricePerGram}
            setBullionsConfig={setBullionsConfig}
            bullionsConfig={bullionsConfig}
            trig={trig}
            trigger={trigger}
            manualPriceLessThanThreshhold={manualPriceLessThanThreshhold}
            manualPriceMoreThanThreshhold={manualPriceMoreThanThreshhold}
            bullionTypes={bullionTypeList}
            isPriceFirstLoading={isPriceFirstLoading}
          />
        </Grid>
      </Box>
    </>
  );
};

export default Buyback;
